import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refresh: false,
};

export const branchVerticalSlice = createSlice({
    name: 'branchVertical',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            state.refresh = action.payload.refresh;
        }
    },
});

export const { setRefresh } = branchVerticalSlice.actions;
export default branchVerticalSlice.reducer;
